import { escapeHtml } from '../html.ts';
import { markdownToHtml } from '../markdown.ts';
import { formatDate, t, today } from '../i18n.ts';
import { brand } from '../state.ts';

/** Print view for generated Markdown (status reports); the browser's print dialog saves it as PDF. */

const PRINT_CSS = `
  @page { size: A4; margin: 18mm 16mm; }
  body { font: 10.5pt/1.5 system-ui, -apple-system, "Segoe UI", sans-serif; color: #1d1b26; background: #fff; margin: 0; }
  header { display: flex; align-items: center; gap: 10px; border-bottom: 2px solid #6d4aff; padding-bottom: 8px; margin-bottom: 14px; }
  header img { width: 28px; height: 28px; }
  header span { font-size: 9pt; color: #5b5870; }
  h1 { font-size: 17pt; margin: 0 0 6px; }
  h2 { font-size: 12pt; margin: 16px 0 4px; color: #3b2a8f; break-after: avoid; }
  ul { margin: 0; padding-left: 18px; }
  li { margin: 2px 0; break-inside: avoid; }
  footer { margin-top: 20px; font-size: 8.5pt; color: #5b5870; border-top: 1px solid #d9d6e5; padding-top: 6px; }
  @media screen { body { max-width: 780px; margin: 24px auto; padding: 0 16px; } }
`;

export function printMarkdown(title: string, markdown: string): void {
  const win = window.open('', '_blank');
  if (!win) throw new Error(t('Das Druckfenster wurde vom Browser blockiert.'));
  win.document.write(`<!doctype html><html lang="${document.documentElement.lang}"><head><meta charset="utf-8">
    <title>${escapeHtml(title)}</title><style>${PRINT_CSS}</style></head><body>
    <header><img src="${escapeHtml(new URL(brand.logo, location.href).href)}" alt=""><span>${escapeHtml(brand.name)}</span></header>
    <main>${markdownToHtml(markdown)}</main>
    <footer>${escapeHtml(t('Erstellt am {date}', { date: formatDate(today()) }))}</footer></body></html>`);
  win.document.close();
  // Print once the logo has loaded, or after a short fallback delay.
  let printed = false;
  const print = () => {
    if (printed || win.closed) return;
    printed = true;
    win.focus();
    win.print();
  };
  win.addEventListener('load', print, { once: true });
  setTimeout(print, 800);
}
